module.exports = __webpack_public_path__ + "static/img/company_created.bc4406d5.svg";